import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marine-contact-create-edit',
  templateUrl: './marine-contact-create-edit.component.html',
  styleUrls: ['./marine-contact-create-edit.component.scss']
})
export class MarineContactCreateEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
